<template>
  <header class="container-fluid header-container">
    <div class="header container">
      <div class="row justify-content-between align-items-center">
        <router-link
          to="/"
          class="header-logo-link col-auto col-md-1 col-lg-auto"
          @click="onLogoClick"
        >
          <img
            class="header-logo"
            src="../../../assets/logo.png"
            alt="4castersports Logo"
          />
        </router-link>
        <sports-navigation />
        <account-info />
      </div>
    </div>
  </header>
</template>

<script setup>
import AccountInfo from '@/components/global/header/AccountInfo.vue';
import SportsNavigation from '@/components/global/header/SportsNavigation.vue';
import { useRoute } from 'vue-router';
import { emitter } from '@/core/emitter';

const route = useRoute();

// Clicking the logo while already on the homepage is a same-route push
// (no navigation event), so an active home search would stay on screen —
// tell the homepage to reset to its default state instead.
function onLogoClick() {
  if (route.path === '/') {
    emitter.emit('resetHomeSearch');
  }
}
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/main.scss';

.header-link {
  display: inline-block;
  margin-left: 3rem;
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    margin-left: 0.2rem;
    font-size: main.$font-size-sm;
    color: main.$grey-300;
  }

  &:hover,
  &.router-link-active {
    color: main.$white;
    text-decoration: none;

    transform: scale(1.2);
    transition: transform 0.3s;
  }
}
.header-container {
  background: main.$color-primary;
  border-bottom: 1px solid rgba(108, 118, 219, 0.12);
  z-index: 1000;
  background-repeat: no-repeat;
  background-position: calc(100% + 59px) 100%;
  background-size: 480px auto;

  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    background-image: none;
  }

  .header {
    margin: 0 auto;
    padding: 20px 0;
    min-height: 70px;

    @media screen and (max-width: map.get(main.$grid-breakpoints, lg)) {
      max-width: 100%;
    }

    @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
      padding: 0.5rem 0;
      min-height: 49px;
    }

    @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
      .row {
        flex-wrap: nowrap;
      }
    }

    &-logo {
      height: 85px;
      width: auto;

      @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
        height: 50px;
      }

      @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
        height: 45px;
      }

      @media screen and (max-width: 370px) {
        height: 40px;
      }
    }
    .menu-close-btn {
      font-size: 1.5rem;
      line-height: 16px;
    }
    .mobile-menu-btn {
      display: none;
      color: main.$white;
      padding: 0 0.5rem;
      margin-left: -0.5rem;
      height: 100%;
      @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
        display: block;
      }
    }
    nav {
      flex-grow: 1;
      display: flex;
      z-index: 10;

      @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
        display: none;
        top: 48px;
        left: 0;
        width: 100%;
        flex-direction: column;
        background: main.$color-primary;
        padding: 1rem 0;

        a,
        .router-link {
          border-radius: 0;
        }
      }
      &.mobileShown {
        display: flex;
      }

      a,
      .router-link {
        color: main.$white;
        font-weight: main.$font-weight-semibold;
        text-shadow: none;
        padding: 0.4rem 0.85rem;
        border-radius: 6px;
        transition: background 0.2s, color 0.2s;
        font-size: 14px;
        letter-spacing: 0.02em;

        &:hover {
          background: rgba(108, 118, 219, 0.15);
          text-decoration: none;
        }
        &.router-link-active {
          background: rgba(108, 118, 219, 0.2);
          text-decoration: none;
        }
        @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
          font-weight: main.$font-weight-base;
        }
      }
    }
  }
}
</style>
